import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-optional-subject-selection',
  templateUrl: './optional-subject-selection.component.html',
  styleUrls: ['./optional-subject-selection.component.scss']
})
export class OptionalSubjectSelectionComponent implements OnInit {
  optionalForm: FormGroup;
  dialogRef: MatDialogRef<any>;

  sessionList: any[] = [];
  SessionFilterList: any[] = [];
  facultyList: any[] = [];
  filteredFacultyList: any[] = [];
  courseList: any[] = [];
  filteredCourseList: any[] = [];
  courseStreamList: any[] = [];
  filteredStreamList: any[] = [];
  examList: any[] = [];
  filteredExamList: any[] = [];
  stucourseClgMapList: any[] = [];
  filteredstucourseClgMapListList: any[] = [];

  disabled = false;
  showtxt = false;
  notOpen = false;
  AdmClosed = false;
  FromDate: Date;
  ToDate: Date;
  BranchId = 0;
  StrCode: any;
  InstId: any;
  OptSub = false;
  noCheckboxSelected = false;
  selectedCheckboxes: any[] = [];
  validationErrors: { [key: string]: string } = {};
  disableButton = true;
  submitButton = true;
  updateButton = false;
  msgShow = false;
  Message = '';
  msgFail = false;
  Message2 = '';

  GroupData: any[] = [];
  optData: any[] = [];
  selectedOptions: any[] = [];

  private savedBranchId: number = null;
  private savedExamId: number = null;
  private savedOptionalEsIds: number[] = [];

  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  session = sessionStorage.getItem('session');
  studentPrn = sessionStorage.getItem('LoginName') || '';
  CourseCodeee = sessionStorage.getItem('StuCoId');

  constructor(
    private fb: FormBuilder,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.OptSub = false;
    this.noCheckboxSelected = false;
    this.notOpen = false;
    this.AdmClosed = false;
    this.validationErrors = {};
    this.submitButton = true;
    this.updateButton = false;
    this.disabled = false;
    this.BranchId = 0;

    this.optionalForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      SubSession: new FormControl(''),
      SubFacId: new FormControl(''),
      SubCoId: new FormControl(''),
      SubBrId: new FormControl(''),
      SubEmId: new FormControl(''),
      SubCgId: new FormControl(''),
      StuSubjectRg: new FormControl('')
    });

    this.loadExistingSubjectSelectionFirst();
  }

  private loadExistingSubjectSelectionFirst() {
    if (!this.StudentPersonalId || !this.session) {
      this.startNormalFlow();
      return;
    }
    const payload = { StuId: this.StudentPersonalId, SubSession: parseInt(this.session) };
    this.umsService.getSubSelectionDetails(payload).subscribe({
      next: (res) => {
        if (res.status && res.data && res.data.length) {
          const data = res.data[0];
          this.savedBranchId = data.SubBrId;
          this.savedExamId = data.SubEmId;
        }
        this.startNormalFlow();
      },
      error: () => this.startNormalFlow()
    });
  }

  private startNormalFlow() {
    this.getApplyData();
    this.getAdmissionDetails();
    this.getScretData();
    this.getSessionData();
  }

  getScretData() {
    this.spinner.show();
    this.umsService.getSecretData().subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) this.InstId = res.projectPharam['ClubPartTrans'];
      },
      error: () => this.spinner.hide()
    });
  }

  getSessionData() {
    this.spinner.show();
    const payload = { SnNo: this.session };
    this.umsService.getSession(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.sessionList = res.data;
          this.SessionFilterList = [...this.sessionList];
          if (this.sessionList.length) {
            this.optionalForm.controls['SubSession'].setValue(this.sessionList[0].SnNo);
          }
        }
      },
      error: (err) => this.handleError(err)
    });
  }

  getApplyData() {
    const payload = { LoginId: sessionStorage.getItem('loginId') };
    this.umsService.getApplyData(payload).subscribe({
      next: (res) => {
        if (res.status) {
          const course = res.data[0]['Course'];
          this.optionalForm.controls['SubCgId'].setValue(res.data[0].College);
          this.getCourse(course);
        }
      },
      error: () => {}
    });
  }

  getCourse(id: string) {
    const payload3 = { CoCode: id };
    this.umsService.fetchstucourseClgMap(payload3).subscribe({
      next: (res) => {
        if (res.status) {
          this.stucourseClgMapList = res.data;
          this.filteredstucourseClgMapListList = [...this.stucourseClgMapList];
        }
      }
    });

    this.umsService.fetchCourseType(payload3).subscribe({
      next: (res) => {
        if (res.status) {
          this.courseList = res.data;
          this.filteredCourseList = [...this.courseList];
          if (this.courseList.length) {
            this.optionalForm.controls['SubCoId'].setValue(this.courseList[0].CoCode);
            this.getFacultyData(this.courseList[0].CoFcCode);
          }
        }
      },
      error: () => this.spinner.hide()
    });

    const payload = { CoCode: id, EmId: 0 };
    this.umsService.fetchCourseBranch(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.courseStreamList = res.data;
          this.filteredStreamList = [...this.courseStreamList];
          if (this.courseStreamList.length) {
            let branchToSelect = this.courseStreamList[0];
            if (this.savedBranchId) {
              const savedBranch = this.courseStreamList.find(b => b.StrId == this.savedBranchId);
              if (savedBranch) branchToSelect = savedBranch;
            }
            this.optionalForm.controls['SubBrId'].setValue(branchToSelect.StrId);
          }
        }
      },
      error: () => {}
    });
  }

  getFacultyData(FcCode: string) {
    this.spinner.show();
    const payload = { FcCode };
    this.umsService.fetchFaculty(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.facultyList = res.data;
          this.filteredFacultyList = [...this.facultyList];
          if (this.facultyList.length) {
            this.optionalForm.controls['SubFacId'].setValue(this.facultyList[0].FcCode);
          }
        }
      },
      error: () => this.spinner.hide()
    });
  }

  getCourseData(id: string) {
    this.spinner.show();
    const payload = { CoFcCode: id };
    this.umsService.fetchCourseType(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.courseList = res.data;
          this.filteredCourseList = [...this.courseList];
          if (this.courseList.length) {
            this.optionalForm.controls['SubCoId'].setValue(this.courseList[0].CoCode);
            this.getExamStreamData(this.courseList[0].CoCode);
          }
        }
      },
      error: () => this.spinner.hide()
    });
  }

  getExamStreamData(id: string) {
    this.spinner.show();
    this.filteredExamList = [];
    this.GroupData = [];
    this.OptSub = false;

    const branchPayload = { CoCode: id, EmId: 0 };
    this.umsService.fetchCourseBranch(branchPayload).subscribe({
      next: (branchRes) => {
        if (branchRes.status) {
          this.courseStreamList = branchRes.data;
          this.filteredStreamList = [...this.courseStreamList];
          if (this.courseStreamList.length) {
            let branchToSelect = this.courseStreamList[0];
            if (this.savedBranchId) {
              const savedBranch = this.courseStreamList.find(b => b.StrId == this.savedBranchId);
              if (savedBranch) branchToSelect = savedBranch;
            }
            this.optionalForm.controls['SubBrId'].setValue(branchToSelect.StrId);
            this.getBrId(branchToSelect.StrId, branchToSelect.StrCode);
          }

          const examPayload = { EmCoCode: id, EmId: 0 };
          this.umsService.fetchExam(examPayload).subscribe({
            next: (examRes) => {
              if (examRes.status) {
                this.examList = examRes.data;
                this.filteredExamList = [...this.examList];
                if (this.examList.length) {
                  let examToSelect = this.examList[0];
                  if (this.savedExamId) {
                    const savedExam = this.examList.find(e => e.EmId === this.savedExamId);
                    if (savedExam) examToSelect = savedExam;
                  }
                  this.optionalForm.controls['SubEmId'].setValue(examToSelect.EmId);
                  this.validateAndLoadOptionalGroups(examToSelect.EmId, this.BranchId);
                }
              }
              this.spinner.hide();
            },
            error: () => this.spinner.hide()
          });
        } else {
          this.spinner.hide();
        }
      },
      error: () => this.spinner.hide()
    });
  }

  getBrId(id: number, code: string) {
    this.BranchId = id;
    this.StrCode = code;
    console.log('BranchId set to:', this.BranchId);
  }

  onExamChange(selectedEmId: number): void {
    const selectedExam = this.examList.find(exam => exam.EmId === selectedEmId);
    if (selectedExam) {
      this.validateAndLoadOptionalGroups(selectedExam.EmId, this.BranchId);
    }
  }

  validateAndLoadOptionalGroups(emId: number, strId: number) {
    const rawForm = this.optionalForm.getRawValue();
    const payload = {
      SnNo: rawForm.SubSession,
      InCode: 'SubSe',
      CoCode: rawForm.SubCoId,
      CgCode: rawForm.SubCgId,
      EmId: emId
    };

    this.spinner.show();
    this.umsService.CheckValidDate(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          const today = new Date();
          const todayDateString = today.toISOString().split('T')[0];
          const validRecords = res.data.filter(record =>
            record.EmId == emId &&
            record.CoCgCoCode == rawForm.SubCoId &&
            record.CoCgCgCode == rawForm.SubCgId
          );

          let canOpen = false;
          for (let record of validRecords) {
            const fromDate = record.FromDate.split('T')[0];
            const toDate = record.ToDate.split('T')[0];
            if (fromDate <= todayDateString && todayDateString <= toDate) {
              canOpen = true;
              break;
            }
          }

          if (validRecords.length === 0) {
            this.msgShow = true;
            this.Message = 'Cutoff dates not set for Optional Subject Selection. Please contact administrator.';
            this.OptSub = false;
            this.GroupData = [];
          } else if (!canOpen) {
            this.msgShow = true;
            this.Message = 'Optional Subject Selection is not open or has been closed for the selected exam.';
            this.OptSub = false;
            this.GroupData = [];
          } else {
            this.checkExamEditControlStatus(emId, rawForm.SubSession, rawForm.SubCoId).then(isValid => {
              if (isValid) {
                this.msgShow = false;
                this.Message = '';
                this.getSubDataForExam(emId, strId);
              } else {
                this.msgShow = true;
                this.Message = 'Optional subject selection is not available at this time.';
                this.OptSub = false;
                this.GroupData = [];
              }
            });
          }
        } else {
          this.msgShow = true;
          this.Message = 'Cutoff dates not configured for Optional Subject Selection.';
          this.OptSub = false;
          this.GroupData = [];
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.msgShow = true;
        this.Message = 'Error checking cutoff dates: ' + (err.error?.message || 'Unknown error');
        this.OptSub = false;
        this.GroupData = [];
      }
    });
  }

 private checkExamEditControlStatus(emId: number, sessionId: number, coCode: string): Promise<boolean> {
  return new Promise((resolve) => {
    const schedulePayload = { LoginId: sessionStorage.getItem('userId'), ShSnNo: sessionId };
    this.umsService.getExamSch(schedulePayload).subscribe({
      next: (res) => {
        if (res.status && res.data && res.data.length) {
          const examSchedule = res.data.find((e: any) => e.ShEmId == emId);
          if (examSchedule) {
            const shId = examSchedule.ShId;
            console.log(' Found schedule ShId:', shId);
            const editPayload = { EcShId: shId, EcInCode: 19, EcOpId: sessionStorage.getItem('userId') };
            this.umsService.getSupExamEditRecord(editPayload).subscribe({
              next: (editRes) => {
                if (editRes.status && editRes.data && editRes.data.length > 0) {
                  const hasOpen = editRes.data.some(record => record.EcStatus === 'O');
                  console.log(' Exam Form Edit Control Statuses:', editRes.data.map(r => r.EcStatus));
                  if (hasOpen) {
                    this.showMessage('Exam forms activity is currently open. Optional subject selection is not allowed.', 'error');
                    resolve(false);
                  } else {
                    resolve(true);
                  }
                } else {
                  console.log(' No exam form record found – allowing selection.');
                  resolve(true);
                }
              },
              error: () => {
                console.log('Error fetching exam edit control – allowing selection.');
                resolve(true);
              }
            });
          } else {
            console.log(' No schedule found for this exam – allowing selection.');
            resolve(true);
          }
        } else {
          console.log(' No schedules returned from API – allowing selection.');
          resolve(true);
        }
      },
      error: () => {
        console.log(' Error fetching exam schedule – allowing selection.');
        resolve(true);
      }
    });
  });
}

  getSubDataForExam(emId: number, strId: number) {
    console.log('Loading optional groups for exam:', emId, 'branch:', strId);
    this.spinner.show();
    const payload = { EsEmId: emId, EsStrId: strId };
    this.umsService.getExamSubMapFetch(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status && res.data.children) {
          this.processGroups(res.data.children);
          this.getOptionData(emId, strId);
          this.fetchAndApplySavedSelections();
        } else {
          this.msgShow = true;
          this.Message = 'No optional subjects available for the selected exam and branch.';
        }
      },
      error: () => {
        this.spinner.hide();
        this.msgShow = true;
        this.Message = 'Error loading optional subjects.';
      }
    });
  }

  getSubData(exam: any) {
    this.validateAndLoadOptionalGroups(exam.EmId, this.BranchId);
  }

  private processGroups(children: any[]) {
    this.GroupData = [];
    this.selectedOptions = [];
    children.forEach(element => {
      if (element.EsType === 'G') {
        this.OptSub = true;
        if (element.EsOpCode && element.EsOpCode !== ' ') {
          if (!this.selectedOptions.includes(element.EsOpCode))
            this.selectedOptions.push(element.EsOpCode);
        }
        if (!this.GroupData.some(g => g.EsId === element.EsId))
          this.GroupData.push(element);

        element.children.forEach(child => {
          if (child.EsOpCode && child.EsOpCode !== ' ') {
            if (!this.selectedOptions.includes(child.EsOpCode))
              this.selectedOptions.push(child.EsOpCode);
          }
        });
      }
    });
  }

  private fetchAndApplySavedSelections() {
    const stuId = this.StudentPersonalId;
    const strId = this.BranchId;
    const emId = this.optionalForm.value.SubEmId;
    const sessionNo = parseInt(this.session);

    if (!stuId || !strId || !emId || !sessionNo) {
      console.warn('Cannot fetch saved optional subjects: missing IDs');
      this.submitButton = true;
      this.updateButton = false;
      return;
    }

    const params = {
      StuId: stuId,
      StrId: strId,
      EmId: emId,
      Session: sessionNo
    };

    this.umsService.getSavedOptionalSubjects(params).subscribe({
      next: (res) => {
        if (res.status && res.data && Array.isArray(res.data)) {
          this.savedOptionalEsIds = res.data.map(item => item.EsId);
          console.log('Fetched saved optional EsIds:', this.savedOptionalEsIds);
          this.applySavedSelections();
          if (this.savedOptionalEsIds.length > 0) {
            this.submitButton = false;
            this.updateButton = true;
          } else {
            this.submitButton = true;
            this.updateButton = false;
          }
        } else {
          this.savedOptionalEsIds = [];
          this.submitButton = true;
          this.updateButton = false;
        }
      },
      error: (err) => {
        console.error('Failed to fetch saved optional subjects:', err);
        this.savedOptionalEsIds = [];
        this.submitButton = true;
        this.updateButton = false;
      }
    });
  }

  private applySavedSelections() {
    const savedEsIdsSet = new Set(this.savedOptionalEsIds);
    const allItems = this.getAllFlatItems();
    this.selectedCheckboxes = [];
    allItems.forEach(item => {
      if (savedEsIdsSet.has(item.EsId)) {
        this.selectedCheckboxes.push(item);
      }
    });
    this.validateAllOpCodes();
  }

  private getAllFlatItems(): any[] {
    const flat: any[] = [];
    this.GroupData.forEach(group => {
      flat.push(group);
      if (group.children) flat.push(...group.children);
    });
    return flat;
  }

  private getOptionData(EmId: number, BranchId: number) {
    const payload = { OpEmId: EmId, OpStrId: BranchId };
    this.umsService.getOption(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.optData = res.data.filter(opt => this.selectedOptions.includes(opt.OpCode));
          this.validateAllOpCodes();
        }
      },
      error: () => {}
    });
  }

  onCheckboxChanged(event: any, item: any) {
    const isChecked = event.checked;
    const exists = this.selectedCheckboxes.some(x => x.EsId === item.EsId);
    if (isChecked && !exists) this.selectedCheckboxes.push(item);
    else if (!isChecked && exists) this.selectedCheckboxes = this.selectedCheckboxes.filter(x => x.EsId !== item.EsId);
    this.validateAllOpCodes();
  }

  shouldCheckItemForGroup(item: any): boolean {
    return this.selectedCheckboxes.some(x => x.EsId === item.EsId);
  }

  private validateAllOpCodes() {
    this.validationErrors = {};
    this.optData.forEach(rule => {
      const count = this.selectedCheckboxes.filter(i => i.EsOpCode === rule.OpCode).length;
      if (count < rule.OpMin || count > rule.OpMax) {
        this.validationErrors[rule.OpCode] = `Option ${rule.OpCode}: Select min ${rule.OpMin} and max ${rule.OpMax} subjects.`;
      }
    });
    this.disableButton = Object.keys(this.validationErrors).length > 0;
  }

  getValidationErrorsKeys(): string[] {
    return Object.keys(this.validationErrors);
  }

  getAdmissionDetails() {
    const payload = { StuId: this.StudentPersonalId };
    this.umsService.fetchAddmissionDetails(payload).subscribe({
      next: (res) => {
        if (res.status) {
          const adm = res.data[0];
          this.CourseCodeee = adm.StuCoId;
        }
      }
    });
  }

  submitSelection() {
    if (this.disableButton) return;
    if (!this.selectedCheckboxes.length) {
      this.showMessage('Please select at least one subject.', 'error');
      return;
    }

    this.spinner.show();

    const esIdsList = this.selectedCheckboxes.map(item => item.EsId).join(',');

    const payload = {
      Session: parseInt(this.session),
      CoCode: this.optionalForm.value.SubCoId,
      CgCode: this.optionalForm.value.SubCgId,
      PrnNo: this.studentPrn,
      EmId: this.optionalForm.value.SubEmId,
      StrId: this.BranchId,
      EsIds: esIdsList
    };

    const request = this.updateButton
      ? this.umsService.updateOptionalSubjectSelectionDetails(payload)
      : this.umsService.insertOptionalSubjectSelectionDetails(payload);

    request.subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.refreshSavedOptionalSubjectsFromGetApi();
        } else {
          this.showMessage(res.message || 'Failed to save.', 'error');
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.handleError(err);
      }
    });
  }

  private refreshSavedOptionalSubjectsFromGetApi() {
    this.spinner.hide();

    const stuId = this.StudentPersonalId;
    const strId = this.BranchId;
    const emId = this.optionalForm.value.SubEmId;
    const sessionNo = parseInt(this.session);

    if (!stuId || !strId || !emId || !sessionNo) {
      this.submitButton = false;
      this.updateButton = true;
      this.showMessage('Saved successfully, but could not refresh the list.', 'info');
      return;
    }

    const params = { StuId: stuId, StrId: strId, EmId: emId, Session: sessionNo };
    this.umsService.getSavedOptionalSubjects(params).subscribe({
      next: (res) => {
        if (res.status && res.data) {
          this.savedOptionalEsIds = res.data.map(item => item.EsId);
          this.applySavedSelections();
        } else {
          this.savedOptionalEsIds = [];
        }
        if (this.savedOptionalEsIds.length > 0) {
          this.submitButton = false;
          this.updateButton = true;
          this.showMessage('Optional subjects saved successfully.', 'success');
        } else {
          this.submitButton = true;
          this.updateButton = false;
          this.showMessage('No optional subjects were saved.', 'error');
        }
      },
      error: (err) => {
        console.error('GET refresh error:', err);
        this.submitButton = false;
        this.updateButton = true;
        this.showMessage('Saved, but could not refresh the list.', 'info');
      }
    });
  }

  private showMessage(msg: string, type: 'success' | 'error' | 'info') {
    const data = {
      message: msg,
      title: type === 'success' ? 'Information' : (type === 'error' ? 'Error' : 'Information'),
      icon: type === 'success' ? 'fas fa-check' : 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup(AlertboxComponent, data);
    if (type === 'success') {
      this.dialogRef.afterClosed().subscribe(() => location.reload());
    }
  }

  private handleError(error: HttpErrorResponse) {
    this.spinner.hide();
    this.showMessage(error.error?.message || 'Something went wrong.', 'error');
  }

  scrutenylevelCheck(item: any) {}
  cutoff(code: string) {}
}